module.exports = __webpack_public_path__ + "static/assets/a0a90c702a2ed80a7b95db69f8813110.svg";